import PocketBase from 'pocketbase';

// Create PocketBase client instance optimized for Oracle platform
const createPocketBaseClient = () => {
  const client = new PocketBase(process.env.REACT_APP_POCKETBASE_URL || 'https://oraculo.buenaar.app');
  
  // Disable auto-cancellation for stability
  client.autoCancellation(false);
  
  // Disable realtime features entirely for Oracle platform
  // Oracle uses single-user sessions and doesn't need real-time updates
  client.realtime = {
    connect: () => Promise.resolve(),
    disconnect: () => {},
    subscribe: () => () => {}, // Returns empty unsubscribe function
    unsubscribe: () => {},
    isConnected: false
  };
  
  console.log('🗄️ PocketBase client initialized (realtime disabled for Oracle platform)');
  
  return client;
};

const pb = createPocketBaseClient();

export default pb;